@keyframes answersExpand {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes summaryFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes overlayIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes dialogIn {
  from {
    opacity: 0;
    transform: scale(0.93);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.configurator_section {
  position: relative;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 15px;

  @media (max-width: 767px) {
    padding: 10px;
  }
}

.questions_list {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-top: 12px;
}

.question_item {
  border-top: 1px solid #e0e0e0;
  transition: opacity 0.25s ease;

  &:last-child {
    border-bottom: 1px solid #e0e0e0;
  }

  &.locked {
    opacity: 0.7;
    pointer-events: none;
  }
}

.question_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: transparent;
  border: none;
  padding: 12px 0;
  cursor: pointer;
  text-align: left;
  gap: 10px;
}

.answer_summary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0 10px;
  animation: summaryFadeIn 0.22s ease both;
}

.answer_summary_icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  flex-shrink: 0;
}

.answer_summary_label {
  font-family: var(--font-family, 'Roboto, sans-serif');
  font-size: 13px;
  font-weight: 600;
  color: #000;
}

.question_text {
  font-family: var(--font-family, 'Roboto, sans-serif');
  font-size: 16px;
  font-weight: 400;
  color: #5c5c5c;
  line-height: 1.4;
  transition: color 0.2s ease, font-weight 0.2s ease;

  strong {
    color: #000;
    font-weight: 700;
  }
}

.expanded .question_text {
  color: #000;
  font-weight: 400;
}

.chevron {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: #5c5c5c;

  svg {
    transition: transform 0.25s ease;
  }

  &.chevron_expanded svg {
    transform: rotate(180deg);
  }
}

.answers_grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 4px 0 14px;
  animation: answersExpand 0.25s ease both;

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.answer_option {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 10px 12px;
  background: #fff;
  border: 2px solid #d3d3d3;
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.18s ease, background-color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
  min-height: 110px;

  &:hover {
    border-color: #aaa;
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  }

  &.selected {
    background: #e8f0fb;
    border-color: #4a80d4;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(74, 128, 212, 0.2);
  }

  @media (max-width: 767px) {
    padding: 10px 8px;
    min-height: 90px;
  }
  [alt="Yes"], [alt="No"] {
    width: 50%;
  }
}

.answer_icon {
  width: 100%;
  height: auto;
  object-fit: contain;
  flex-shrink: 0;

  @media (max-width: 767px) {
    width: 100%;
    height: auto;
  }
}

.fronts_only_overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  animation: overlayIn 0.2s ease both;
}

.fronts_only_dialog {
  background: #fff;
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  padding: 24px 28px;
  max-width: 320px;
  width: 90%;
  text-align: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  animation: dialogIn 0.25s ease both;

  p {
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000;
    margin: 0 0 18px;
    line-height: 1.5;
  }
}

.fronts_only_confirm {
  background: #B61C34;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 10px 32px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.18s ease, transform 0.18s ease;

  &:hover {
    background: #8f1226;
    transform: translateY(-1px);
  }
}

.fronts_only_reset {
  display: block;
  margin-top: 10px;
  background: #fff;
  color: #B61C34;
  border: 1.5px solid #B61C34;
  border-radius: 5px;
  padding: 10px 32px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.18s ease, color 0.18s ease, transform 0.18s ease;

  &:hover {
    background: #B61C34;
    color: #fff;
    transform: translateY(-1px);
  }
}

.answer_label {
  font-family: var(--font-family, 'Roboto, sans-serif');
  font-size: 13px;
  font-weight: 500;
  color: #000;
  text-align: center;
  line-height: 1.3;
  min-height: 2.6em;

  @media (max-width: 767px) {
    font-size: 16px;
  }
}
